APP.Maintenance = (/** @lends APP.Maintenance */function () {
	'use strict';

	var exports,
		isLoginDisabled = false,
		$body,
		$disabledLoginLayer;

	function init() {
		initDomElements();
		checkMaintenanceTypes();
	}

	function initDomElements() {
		$body = $(document.body);
		$disabledLoginLayer = APP.Template.get('disabled-login-popup');
	}

	function checkMaintenanceTypes() {
		isLoginDisabled = $body.attr('data-disable-login') !== undefined;
	}

	function showDisabledLoginLayer() {
		APP.Overlay.setContent($disabledLoginLayer({}), true, true);
		APP.Overlay.open();
	}

	exports = {
		init: init,
		showDisabledLoginLayer: showDisabledLoginLayer,
		isLoginDisabled: function () {
			return isLoginDisabled;
		}
	};

	/* test-code */
	/* eslint no-underscore-dangle: 0 */
	exports.__testonly__ = {};
	/* end-test-code */

	return exports;

}());
